import { render, staticRenderFns } from "./CreateFamousSchoolForm.vue?vue&type=template&id=70ad0938"
import script from "./CreateFamousSchoolForm.vue?vue&type=script&lang=js"
export * from "./CreateFamousSchoolForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports